import { render, staticRenderFns } from "./header-info.vue?vue&type=template&id=d8c76cf4&scoped=true&"
import script from "./header-info.vue?vue&type=script&lang=js&"
export * from "./header-info.vue?vue&type=script&lang=js&"
import style0 from "./header-info.vue?vue&type=style&index=0&id=d8c76cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c76cf4",
  null
  
)

export default component.exports